import { composer } from '../../../component-decorators/composer';
import { Tag } from '@wix/design-system';
import * as React from 'react';
import s from './category-header-mobile.scss';

export const SelectorTagMobile = composer()
  .withMarketplaceStore()
  .withTranslation()
  .compose(({ name, slug, t }) => {
    return (
      <Tag
        className={
          name === t('category.filter-subcategory.all')
            ? s.selectorButtonAll
            : s.selectorButton
        }
        size="small"
        theme="light"
        dataHook={`${slug}-selector-mobile`}
        id={`${slug}-selector-mobile`}
        removable={false}
      >
        {name}
      </Tag>
    );
  });
